import React from 'react';
import KonfigurationSettings from '../../KonfigurationSettings';

interface Props {
  authToken: string;
}

const AllgemeinSection: React.FC<Props> = ({ authToken }) => (
  <div>
    <h3 style={{ marginTop: 0 }}>Allgemeine Einstellungen</h3>
    <KonfigurationSettings authToken={authToken} />
  </div>
);

export default AllgemeinSection;
